import { render, staticRenderFns } from "./InitioPageHeaderAndFooter.vue?vue&type=template&id=bc6e736a&scoped=true&"
import script from "./InitioPageHeaderAndFooter.vue?vue&type=script&lang=js&"
export * from "./InitioPageHeaderAndFooter.vue?vue&type=script&lang=js&"
import style0 from "./InitioPageHeaderAndFooter.vue?vue&type=style&index=0&id=bc6e736a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6e736a",
  null
  
)

export default component.exports